<template>
	<sf-modal-layout size="xl" :title="getMessage_('SWCC000585')" :show="show_" :closeModal="closeModal">
		<el-row :gutter="20">
			<el-col :span="7">
				<sf-input-group
					:label="`* ${getMessage_('SWCC000588')}`"
					labelPosition="left"
					:labelSpan="12"
					:inputValue="selectedRow.stnCd"
					:onChange="value => onChange({ key: 'stnCd', value })"
				/>
			</el-col>
			<el-col :span="7">
				<sf-input-group
					:label="`* ${getMessage_('SWCC000589')}`"
					labelPosition="left"
					:labelSpan="16"
					:inputValue="selectedRow.stnName"
					:onChange="value => onChange({ key: 'stnName', value })"
				/>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="7">
				<sf-select-group
					:label="`* ${getMessage_('SWCC000590')}`"
					labelPosition="left"
					:labelSpan="12"
					:inputValue="selectedRow.shopCd"
					:options="shopCds"
					:onChange="value => onChange({ key: 'shopCd', value })"
				/>
			</el-col>
			<el-col :span="7">
				<sf-select-group
					:label="`* ${getMessage_('SWCC000591')}`"
					labelPosition="left"
					:labelSpan="16"
					:inputValue="selectedRow.lineCd"
					:options="lines"
					:onChange="value => onChange({ key: 'lineCd', value })"
				/>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="7">
				<sf-select-group
					:label="getMessage_('SWCC000592')"
					labelPosition="left"
					:labelSpan="12"
					:inputValue="selectedRow.cid"
					:options="cids"
					:onChange="value => onChange({ key: 'cid', value })"
				/>
			</el-col>
			<el-col :span="7">
				<sf-select-group
					:label="getMessage_('SWCC000593')"
					labelPosition="left"
					:labelSpan="16"
					:inputValue="selectedRow.hid"
					:options="hids"
					:onChange="value => onChange({ key: 'hid', value })"
				/>
			</el-col>
			<el-col :span="8">
				<sf-select-group
					:label="getMessage_('SWCC000594')"
					labelPosition="left"
					:labelSpan="20"
					:inputValue="selectedRow.bid"
					:options="cids"
					:onChange="value => onChange({ key: 'bid', value })"
				/>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="7">
				<sf-select-group
					:label="getMessage_('SWCC000595')"
					labelPosition="left"
					:labelSpan="12"
					:inputValue="selectedRow.tid"
					:options="cids"
					:onChange="value => onChange({ key: 'tid', value })"
				/>
			</el-col>
			<el-col :span="7">
				<sf-select-group
					:label="getMessage_('SWCC000811')"
					labelPosition="left"
					:labelSpan="16"
					:inputValue="selectedRow.aid"
					:options="cids"
					:onChange="value => onChange({ key: 'aid', value })"
				/>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="24">
				<sf-group-wrapper :label="getMessage_('SWCC000596')" labelPosition="left" :labelSpan="3">
					<el-checkbox
						v-for="(flag, index) in flags"
						:key="index"
						:value="selectedRow[flag.value.toLowerCase()] === 'Y'"
						:style="{ whiteSpace: 'nowrap', width: '25%', marginLeft: '0px' }"
						@change="value => onChange({ key: flag.value.toLowerCase(), value: value ? 'Y' : 'N' })"
					>
						{{ flag.label }}
					</el-checkbox>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="7">
				<sf-input-group
					:label="getMessage_('SWCC000597')"
					labelPosition="left"
					:labelSpan="12"
					inputType="number"
					:inputValue="selectedRow.fairStock"
					:onChange="value => onChange({ key: 'fairStock', value })"
				/>
			</el-col>
			<el-col :span="7">
				<sf-input-group
					:label="getMessage_('SWCC000598')"
					labelPosition="left"
					:labelSpan="16"
					inputType="number"
					:inputValue="selectedRow.maxStock"
					:onChange="value => onChange({ key: 'maxStock', value })"
				/>
			</el-col>
			<el-col :span="8">
				<sf-input-group
					:label="getMessage_('SWCC000599')"
					labelPosition="left"
					:labelSpan="16"
					inputType="number"
					:inputValue="selectedRow.minStock"
					:onChange="value => onChange({ key: 'minStock', value })"
				/>
			</el-col>
		</el-row>
		<template v-slot:footer>
			<sf-button
				v-if="popupParams.type === 'update' && isButton_(scrId, 'CD')"
				v-show="disabled"
				color="error"
				line
				:onClick="deleteAction"
			>
				{{ getMessage_('SWCC000280') }}
			</sf-button>
			<sf-button line :onClick="closeModal">{{ getMessage_('SWCC000243') }}</sf-button>
			<sf-button v-if="isButton_(scrId, 'AD') && popupParams.type === 'update'" v-show="disabled" :onClick="modifyAction">
				{{ getMessage_('SWCC000279') }}
			</sf-button>
			<sf-button v-if="isButton_(scrId, 'AD') && popupParams.type === 'create'" :onClick="registerAction">
				{{ getMessage_('SWCC000245') }}
			</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/RegisterReportingPoint/store/helpers';
import * as yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,

		selectedRow() {
			return this.popupParams.selectedRow;
		},

		disabled() {
			return this.popupParams.type.includes('update');
		},

		schema() {
			return yup.object().shape({
				lineCd: yup.string().nullable().required(this.getMessage_('SWCC000697')),
				shopCd: yup.string().nullable().required(this.getMessage_('SWCC000696')),
				stnName: yup
					.string()
					.nullable()
					.required(this.getMessage_('SWCC000695'))
					.min(1, this.$sf_formatString(this.getMessage_('SWCC000176'), [this.getMessage_('SWCC000689'), 1]))
					.max(50, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('SWCC000689'), 50])),
				stnCd: yup
					.string()
					.nullable()
					.required(this.getMessage_('SWCC000694'))
					.min(1, this.$sf_formatString(this.getMessage_('SWCC000176'), [this.getMessage_('SWCC000688'), 1]))
					.max(20, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('SWCC000688'), 20]))
			});
		}
	},

	methods: {
		...rootMethods,
		...serviceMethods,
		closeModal() {
			this.SET_STATE({
				key: 'popupParams',
				value: { type: '', show: false, selectedRow: {} }
			});
		},

		onChange({ key, value }) {
			let adjustValue = value;
			if (key == 'stnCd' || key == 'stnName') {
				const replaceChar = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi;
				adjustValue = adjustValue.replace(replaceChar, '');
			}

			this.SET_STATE({
				key: 'popupParams',
				value: { ...this.popupParams, selectedRow: { ...this.selectedRow, [key]: adjustValue } }
			});
		},

		registerAction() {
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_('SWCC000555'),
				buttons: [{ title: this.getMessage_('SWCC000245'), clickFn: this.register }]
			});
		},

		modifyAction() {
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_('SWCC000553'),
				buttons: [{ title: this.getMessage_('SWCC000279'), clickFn: this.modify }]
			});
		},

		deleteAction() {
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_('SWCC000554'),
				buttons: [{ title: this.getMessage_('SWCC000280'), clickFn: this.delete }]
			});
		},

		register() {
			try {
				this.schema.validateSync(this.selectedRow);

				if (this.selectedRow.plantCd == null || this.selectedRow.plantCd === '') {
					this.selectedRow.plantCd = this.searchParams.plantCd ? this.searchParams.plantCd : this.user.plantCd;
				}

				this.$sf_toggleLoading(true);
				this.register_({ station: this.selectedRow })
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.then(this.closeModal)
					.finally(() => this.$sf_toggleLoading(false));
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},

		modify() {
			try {
				this.schema.validateSync(this.selectedRow);

				if (this.selectedRow.plantCd == null || this.selectedRow.plantCd === '') {
					this.selectedRow.plantCd = this.searchParams.plantCd ? this.searchParams.plantCd : this.user.plantCd;
				}

				this.$sf_toggleLoading(true);
				this.modify_({ station: this.selectedRow })
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.then(this.closeModal)
					.finally(() => this.$sf_toggleLoading(false));
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},

		delete() {
			try {
				this.schema.validateSync(this.selectedRow);

				this.$sf_toggleLoading(true);
				this.delete_({ station: this.selectedRow })
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.then(this.closeModal)
					.finally(() => this.$sf_toggleLoading(false));
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		}
	}
};
</script>

<style></style>
